// extracted by mini-css-extract-plugin
export default {"leftAlignContentInOwnLine":"SaveNewGameFlow_leftAlignContentInOwnLine__b3cgn"};